import { strings } from ".";

export const dictionary = {
  "ua": {
    [strings.CHATBOT_TITLE]: "Miranda, Ваш віртуальний ассистент",
    [strings.ERROR_PAGE_NOT_FOUND_TITLE]: "Тут нічого немає...",
    [strings.ERROR_PAGE_NOT_FOUND_SUBTITLE]: "...можливо сторінку яку ви шукаєте не знайдено або вона не існує.",
    [strings.ERROR_PAGE_NOT_FOUND_BUTTON]: "Назад на головну",
    [strings.BRAND_NAME]: "Placyy",
    "Find a good job...": "Введіть назву вакансії...",
    [strings.BACK_BUTTON]: "Назад",
    [strings.CANCEL_BUTTON]: "Скасувати",
    [strings.CLEAR_BUTTON]: "Очистити",
    [strings.FIND_BUTTON]: "Знайти",
    [strings.NEXT_BUTTON]: "Наступна",
    [strings.OK_BUTTON]: "Ок",
    [strings.PREVIOUS_BUTTON]: "Назад",
    [strings.SAVE_BUTTON]: "Зберегти",
    [strings.ADD_VACANCY_PAGE_CREATE_VACANCY]: "Створення вакансії ",
    [strings.ADD_VACANCY_PAGE_EDIT_VACANCY]: "Редагування вакансії ",
    [strings.ADD_VACANCY_STEP_ONE_DESCRIPTION]: "Компанії, що вказують інформацію про свою діяльність - швидше знаходять кандидатів.",
    [strings.ADD_VACANCY_STEP_ONE_CONTINUE]: "ПРОДОВЖИТИ",
    [strings.ADD_VACANCY_STEP_ONE_ORGANISATION_NAME]: "Назва компанії",
    [strings.ADD_VACANCY_STEP_ONE_ORGANISATION_DESCRIPTION]: "Інформація про компанію",
    [strings.ADD_VACANCY_STEP_ONE_ORGANISATION_WEBSITE_URL]: "Веб-сайт",
    [strings.ADD_VACANCY_STEP_TWO_CREATE]: "Створити",
    [strings.ADD_VACANCY_STEP_TWO_UPDATE]: "Оновити",
    [strings.ADD_VACANCY_STEP_TWO_JOB_TITLE]: "Посада",
    [strings.ADD_VACANCY_STEP_TWO_JOB_DESCRIPTION]: "Опишіть вакансію",
    [strings.ADD_VACANCY_STEP_TWO_JOB_LOCATION]: "Локація",
    [strings.ERROR_TEXT_REQUIRED]: "Заповніть поле",
    [strings.ERROR_TEXT_SPECIAL_SYMBOLS]: "Некоректні дані",
    [strings.ERROR_TEXT_WEBSITE_URL]: "Некоректний домен",
    [strings.ERROR_TEXT_EMAIL]: "Некоректна електронна адреса",
    [strings.ERROR_TEXT_DATE]: "Некоректний формат дати (дд.мм.рррр)",
    "Failed to send your message, please try again later": "Ваше повідомлення не відправлене, будь-ласка спробуйте пізніше",
    [strings.ERROR_CONFIGURATION_QUERY_COLUMN_MISSING]: "Ой, виявилася деяка невідповідність у нашій системі. У конфігурації бракує кількох стовпців, і це стало причиною цієї ситуації. Не сумнівайтеся, наша служба підтримки готова допомогти вам вирішити це миттєво. Поки що ви можете вибрати інший пункт меню або спробувати пізніше. Ми вдячні за вашу терплячість!",
    [strings.ERROR_CONFIGURATION_QUERY_ERROR]: "Вибачте за незручності! Здається, що виникла проблема з нашою системою. Ми помітили, що деякі елементи конфігурації відсутні, і це призвело до даної ситуації. Будь ласка, зверніться до нашої відзивчивої служби підтримки, і вони швидко нададуть вам допомогу у вирішенні цього питання. У той же час, ви можете вибрати інший пункт меню або спробувати пізніше. Ваше розуміння важливо для нас, і ми вдячні за терпіння!",
    [strings.ERROR_DB_UPDATE_FAILURE]: "Не вдалося оновити базу даних. Будь ласка, спробуйте пізніше або зверніться до служби підтримки",
    [strings.FIND_VACANCY_PLACEHOLDER_VACANCIES_SEARCH]: "Пошук вакансій",
    [strings.FIND_VACANCY_CHAT_TAB]: "Чат",
    [strings.FING_VACANCY_MAIN_TAB]: "Головна",
    [strings.FIND_VACANCY_PROFILE_TAB]: "Профіль",
    [strings.POPUP_VACANCY_CREATED_CREATED]: "Вакансія успішно створена",
    [strings.POPUP_VACANCY_CREATED_UPDATED]: "Вакансія успішно оновлена",
    [strings.POPUP_VACANCY_CREATED_TO_MAIN]: "На головну",
    [strings.POPUP_VACANCY_CREATED_CREATE_ONE_MORE]: "Створити ще одну вакансію",
    [strings.VACANCIES_PAGE_VACANCIES]: "Вакансії",
    [strings.VACANCIES_PAGE_COMPLETED_VACANCIES]: "Завершені",
    [strings.VACANCIES_PAGE_EDIT]: "Редагувати",
    [strings.USER_PAGE_FORM_TITLE]: "Персональні дані",
    [strings.USER_PAGE_NAME_FIELD]: "Ім`я",
    [strings.USER_PAGE_MIDDLE_NAME_FIELD]: "По батькові",
    [strings.USER_PAGE_FAMILY_NAME_FIELD]: "Прізвище",
    [strings.USER_PAGE_BIRTH_DATE_FIELD]: "Дата народження",
    [strings.USER_PAGE_GENDER_CODE_FIELD]: "Стать",
    [strings.USER_PAGE_JOB_TITLE_FIELD]: "Професія",
    [strings.USER_PAGE_DESCRIPTION_FIELD]: "Про себе",
    [strings.USER_PAGE_EMAIL_ADDRESS_FIELD]: "Електронна адреса",
    [strings.USER_PAGE_FAX_FIELD]: "Факс",
    [strings.USER_PAGE_MOBILE_PHONE_FIELD]: "Мобільний номер телефону",
    [strings.USER_PAGE_TELEPHONE1_FIELD]: "Телефон 1",
    [strings.USER_PAGE_TELEPHONE2_FIELD]: "Телефон 2",
    [strings.USER_PAGE_TELEPHONE3_FIELD]: "Телефон 3",
    [strings.USER_PAGE_BIRTH_FORMAT]: "дд.мм.рр",
    [strings.USER_PAGE_EDIT_THE_FIELD]: "Редагувати поле",
    [strings.SIDE_MENU_THEME]: "Темна тема",
    [strings.WITH_RETRY_WENT_WRONG]: "Щось пішло не так",
    [strings.WITH_RETRY_TRY_AGAIN]: "Будь ласка повторіть спробу або перезавантажте сторінку.",
    [strings.WITH_RETRY_BUTTON]: "Повторити спробу",
    "Oops! Something went wrong. Please try refreshing the page or check back later.": "Щось пішло не так! Перезавантажте сторінку або спробуйте пізніше.",
    [strings.CHAT_MESSAGE]: "Зацікавила вакансія? Напишіть нам сюди",
    [strings.CHAT_SEND]: "Надіслати",
    [strings.CHAT_CHATS]: "Чати",
    [strings.CHAT_YESTERDAY]: "Вчора",
    [strings.CHAT_TODAY]: "Сьогодні",
    [strings.CHAT_MY_CHATS]: "Мої чати",
    [strings.FLOATING_MARKER_SELECT]: "Вибрати",
    [strings.MAP_SEARCH_HERE]: "Шукати вакансії",
    [strings.EMPTY_VACANCY_LIST]: "Наразі немає вакансій, які відповідають Вашому запиту. Будь ласка, змініть місце пошуку або масштаб карти і ми обов'язково щось знайдемо!",
    [strings.EMPTY_CHAT_LIST]: "Поки що ніяких повідомлень немає.",
    [strings.SELECT_CHAT]: "Оберіть чат для листування",
    [strings.EMPTY_LIST_PARAGRAPH_1]: "Здається ви знайшли роботу, якої ще немає. Однак не хвилюйтеся, все в повному порядку.",
    [strings.EMPTY_LIST_PARAGRAPH_2]: "Ось декілька варіантів:",
    [strings.EMPTY_LIST_PARAGRAPH_3]: "Ви можете спробувати пошук у дещо іншій області, щоб знайти роботу, яку ви шукали.",
    [strings.EMPTY_LIST_PARAGRAPH_4]: "Спробйте інший заголовок і будь ласка уникайте скорочень.",
    [strings.EMPTY_LIST_PARAGRAPH_5]: "Я хочу отримувати актуальні сповіщення по роботі CONST_JOBS_SEARCH_NAME в районі",
    [strings.EMPTY_LIST_INPUT_EMAIL]: "Введіть свій email",
    [strings.EMPTY_LIST_SUBSCRIBE]: "Підписатися",
    [strings.CONTACT_GIVEN_NAME_MIN_LENGTH_ERROR]: "Ім'я повинно містити принаймні 2 символи",
    [strings.CONTACT_GIVEN_NAME_MAX_LENGTH_ERROR]: "Занадто довге ім'я. Будь ласка, обмежте введення до 50 символів або менше",
    [strings.CONTACT_GIVEN_NAME_IS_REQUIRED_ERROR]: "Будь ласка, надайте ім'я",
    [strings.CONTACT_GIVEN_NAME_PATTERN_ERROR]: "Будь ласка, використовуйте лише літери",
    [strings.CONTACT_BIRTH_DATE_MIN_LENGTH_ERROR]: "Будь ласка, введіть правильну дату народження",
    [strings.CONTACT_PHOTO_MAX_ERROR]: "Файл занадто великий, будь-ласка виберіть фото розміром меньше 15 кілобайт.",
    //amplify
    [strings.LOGIN_FAMILY_NAME]: "Прізвище",
    [strings.LOGIN_NAME]: "Ім`я",
    [strings.LOGIN_ENTER_NAME]: "Введіть ім`я",
    [strings.LOGIN_EMAIL]: "Електронна пошта",
    'Phone number': 'Телефон',
    [strings.LOGIN_PASSWORD]: "Пароль",
    [strings.LOGIN_CONFIRM_PASSWORD]: "Підтвердіть пароль",
    [strings.LOGIN_CONFIRMATION_CODE]: "Код підтвердження",
    [strings.LOGIN_TERMS_CONDITIONS_CHECKBOX]: "Я погоджуюсь з умовами користування",
    [strings.LOGIN_TERMS_CONDITIONS]: "Ви маєте погодитися з умовами користування",
    [strings.LOGIN_RIGHTS_RESERVED]: "Всі права захищені",
    [strings.LOGIN_CREATE_NEW_PASSWORD_HEADING]: "Новий пароль",
    'Sing up': "Зареєструватися",

    //Customisations
    'Use this form to create new and edit existing vacancies': 'Створення нових та редагування існуючих вакансій',
    'Vacancy': "Вакансія",
    'Unpublished draft': 'Чернетка, вакансія не опублікована',
    'Open for applications': 'Відкрито для заявок',
    'Closed for applications': 'Заявки не приймаються',
    'Job title': 'Назва вакансії',
    'Vacancy address': 'Адреса вакансії',
    'Street, building and city': 'Місто, вулиця і будинок',
    'Salary': 'Заробітня плата (грн/міс)',
    'Hello message': 'Автоматичне вступне повідомлення',
    'Please enter a valid and engaging message': 'Будь ласка, введіть цікаве та привабливе повідомлення кандидату',
    'Vacancy status': 'Статус вакансії',
    'My active vacancies': 'Мої відкриті вакансії',
    'All vacancies': 'Всі вакансії',

    //Organisation
    'Organisation name': 'Назва компанії',
    'Company registration number': 'ЄДРПОУ',
    'Organisation crn': 'ЄДРПОУ',
    'Organisation website url': 'Веб адреса',
    'Number of employees': 'Кількість працівників',
    'Organisation description': 'Коротко про нас',
    'Use this form to update organisation details': 'Редагування інформації про компанію',

    //Contact
    'Family name': 'Прізвище',
    'Given name': 'Ім`я',
    'Telephone 1': 'Телефон',

    //Validation
    'This field is required': 'Заповніть поле',
    'Organisation': 'Компанія',
    'My organisation': 'Профіль компанії',
    'Administration': 'Адміністрування',
    'Contacts': 'Контакти',
    'My contacts': 'Мої контакти',
    'Dashboard': 'Панель управління',

    // The following dictionary entries have plain text keys because they are used only in Amplify UI.
    'Account recovery requires verified contact information': 'Відновлення облікового запису потребує контактної інформації',
    'Back to Sign In': 'Назад на сторінку входу',
    'Change Password': 'Змінити пароль',
    Changing: 'Змінюємо',
    Code: 'Код',
    'Confirm Password': 'Підтвердіть пароль',
    'Confirm Sign Up': 'Підтвердіть реєстрацію',
    'Confirm SMS Code': 'Підтвердіть SMS код',
    'Confirm TOTP Code': 'Підтвердіть TOTP код',
    Confirm: 'Підтвердити',
    'Confirmation Code': 'Код підтвердження',
    Confirming: 'Підтверджуємо',
    'Create a new account': 'Зареєструватися',
    'Create Account': 'Зареєструватися',
    'Creating Account': 'Реєструємо',
    'Dismiss alert': 'Відхилити сповіщення',
    Email: 'Email',
    'Enter your code': 'Введіть код',
    'Enter your email': 'Введіть ваш email',
    'Enter your phone number': 'Введіть ваш номер телефону',
    'Enter your username': 'Введіть ваше імʼя користувача',
    'Forgot password?': 'Забули пароль?',
    'Forgot your password?': 'Забули ваш пароль?',
    'Hide password': 'Сховати пароль',
    'It may take a minute to arrive': 'Отримання може тривати певний час',
    Loading: 'Завантаження',
    'New password': 'Новий пароль',
    or: 'або',
    Password: 'Пароль',
    'Phone Number': 'Номер Телефону',
    'Resend Code': 'Надіслати код повторно',
    'Reset your password': 'Скинути пароль',
    'Reset your Password': 'Скинути пароль',
    'Send code': 'Надіслати код',
    'Send Code': 'Надіслати код',
    Sending: 'Надсилання',
    'Setup TOTP': 'Налаштувати TOTP',
    'Show password': 'Показати пароль',
    'Sign in to your account': 'Увійдіть у ваш обліковий запис',
    'Sign In with Amazon': 'Увійти з Amazon',
    'Sign In with Apple': 'Увійти з Apple',
    'Sign In with Facebook': 'Увійти з Facebook',
    'Sign In with Google': 'Увійти з Google',
    'Sign in': 'Увійти',
    'Signing in': 'Вхід',
    Skip: 'Пропустити',
    Submit: 'Надіслати',
    Submitting: 'Надсилання',
    Username: 'Імʼя користувача',
    'Verify Contact': 'Підтвердити Контакт',
    Verify: 'Підтвердити',
    'We Emailed You': 'Ми надіслали вам Email',
    'We Sent A Code': 'Ми надіслали код',
    'We Texted You': 'Ми надіслали вам текстове повідомлення',
    'Your code is on the way. To log in, enter the code we emailed to': 'Ваш код вже в дорозі. Щоб увійти, введіть код, що ми надіслали вам на Email',
    'Your code is on the way. To log in, enter the code we sent you': 'Ваш код вже в дорозі. Щоб увійти, введіть код, що ми вам надіслали',
    'Your code is on the way. To log in, enter the code we texted to': 'Ваш код вже в дорозі. Щоб увійти, введіть код, що ми надіслали вам текстовим повідомленням',

    // Additional translations
    'An account with the given email already exists.': 'Обліковий запис з цим Email вже існує.',
    'Confirm a Code': 'Підтвердіть код',
    'Confirm Sign In': 'Підтвердіть вхід',
    'Forgot Password': 'Забули пароль',
    'Incorrect username or password.': 'Невірне імʼя користувача або пароль',
    'Invalid password format': 'Невірний формат паролю',
    'Invalid phone number format': 'Невірний формат номеру телефону',
    'Invalid verification code provided, please try again.': 'Невірний код, будь ласка спробуйте знову',
    'Loading...': 'Завантаження...',
    'New Password': 'Новий пароль',
    'Resend a Code': 'Надіслати код повторно',
    'Reset Password': 'Скинути пароль',
    'Sign Out': 'Вийти',
    'Sign Up with Amazon': 'Зареєструватися з Amazon',
    'Sign Up with Apple': 'Зареєструватися з Apple',
    'Sign Up with Facebook': 'Зареєструватися з Facebook',
    'Sign Up with Google': 'Зареєструватися з Google',
    'Sign Up': 'Зареєструватися',
    'User already exists': 'Користувач вже існує',
    'User does not exist.': 'Такий користувач не існує',
    'Username cannot be empty': 'Імʼя користувача не може бути пустим',
    'Your passwords must match': 'Паролі мають збігатися',
    'Username/client id combination not found.': "Ім'я користувача не знайдено",
    'Username should be an email.': "Невірний Email",
    'Password did not conform with policy: Password must have uppercase characters': 'Пароль не відповідає політиці: пароль має містити великі літери',
    'Password did not conform with policy: Password not long enough': 'Пароль не відповідає політиці: пароль недостатньо довгий',
    'Password did not conform with policy: Password must have lowercase characters': 'Пароль не відповідає політиці: пароль має містити малі літери.',
    'Password did not conform with policy: Password must have symbol characters': 'Пароль не відповідає політиці: пароль має містити символи',
    'PreTokenGeneration failed with error .': `Будь-ласка перевірте ім'я користувача та пароль.`,
    'Menu': 'Меню',
    'Welcome to DocuMate — your secure gateway to smarter documents. Log in to chat with your files, safely and privately.': 'Програма для пошуку роботи'
  },
  en: {
    'Create Account': 'Sign up',
    'PreTokenGeneration failed with error .': 'Please verify your user name and password',
    'Знайдіть роботу прямо зараз!': 'Find your job here and now!',
    'Шукаю персонал': 'Looking for staff',
    'Тільки активні вакансії недалеко від дому вже сьогодні.': 'Only active vacancies close to home today.',
    'Де шукаємо?': 'Where are we looking?',
    'Яку роботу?': 'What job?',
    'Наші послуги потребують інформації про вашу геолокацію. Будь ласка, увімкніть доступ до місцезнаходження в налаштуваннях вашого браузера, це дасть вам можливість знайти роботу на нашому веб-сайті.': 'Our services require information about your geolocation. Please enable location access in your browser settings, this will enable you to find jobs on our website.',
    'Знайти': 'Find',
    'Закрийте вакансію за один день': 'Close the vacancy in one day',
    'Знайдіть вашого кандидата онлайн за допомогою платформи з активною базою  шукачів роботи': 'Find your candidate online using a platform with an active database of job seekers',
    'Зареєструйтесь як роботодавець': 'Register as an employer',
    'Легко': 'Easy',
    'Швидко та легко знайти вакансії': 'Find jobs quickly and easily',
    'Втомилися від тривалих поїздок і виснажливих пошуків роботи? Placyy тут, щоб полегшити ваше життя! Ми знайомимо шукачів роботи з роботодавцями в їхній місцевості, усуваючи потребу в довгих поїздках і тривалих пошуках.': 'Tired of long trips and tiresome job searches? Placyy is here to make your life easier! We connect job seekers with employers in their area, eliminating the need for long commutes and time-consuming searches.',
    'Швидко': 'Instant',
    'Унікальний пошуковий алгоритм': 'Unique search algorithm',
    'Шукаєте швидкий спосіб знайти кандидатів на ваші вакансії? Вам допоможе Placyy! Наша платформа дозволяє онлайн зв’язатися з шукачами роботи у вашому регіоні. Наша база даних шукачів роботи оновлюється щодня, тому ви отримуєте доступ до релевантних і реальних кандидатів.': 'Looking for a quick way to find candidates for your vacancies? Placyy will help you! Our platform allows you to connect online with job seekers in your area. Our database of job seekers is updated daily, so you get access to relevant and real candidates.',
    'З додатком - цікавіше!': 'With the application - more interesting!',
    'Шукаю роботу': 'I am looking for a job',
    'Реєстрація для роботодавців': 'Registration for employers',
    'Шукаю персонал ': 'Looking for staff',
    'Реєстрація для шукачів роботи': 'Registration for job seekers',
    'Зробіть крок до своєї ідеальної роботи разом з ': 'Take a step towards your ideal job with ',
    'Поруч': 'Close',
    'Ваші вакансії вже поряд з вами': 'Your vacancies are already near you',
    'Втомилися від тривалих поїздок і виснажливих пошуків роботи? Placyy тут, щоб полегшити ваше життя! Ми знайомимо шукачів роботи з роботодавцями в їхній місцевості, усуваючи потребу в довгих поїздках і тривалих пошуках, наша команда працює 24 години на день з турботою про Вас.': 'Tired of long trips and tiresome job searches? Placyy is here to make your life easier! We connect job seekers with employers in their area, eliminating the need for long commutes and time-consuming searches, our team works 24 hours a day with you in mind.',
    'Надійно': 'Dependable',
    'Сама надійна та перевірена інформація': 'The most reliable and verified information',
    'З нами легко знайти вакансії саме для Вас': 'With us, it is easy to find vacancies just for you',
    'Завдяки великій базі вакансій Placyy приводить знайомства між роботодавцями та пошукачами роботи в одному місці, забезпечуючи легкість і зручність, тим самим економлячи ваш час та зусилля.': 'With a large database of jobs, Placyy brings together employers and job seekers in one place, providing ease and convenience, thereby saving your time and effort.',
    'Достовірна інформація -це важливий елемент у процесі Вашого карєрного росту. Placyy допомагає приймати обґрунтовані рішення, визначати кращі вакансії та забезпечує успіх у професійному розвитку та досягненні цілей': 'Reliable information is an important element in the process of your career growth. Placyy helps you make informed decisions, identify the best vacancies and ensure success in professional development and achievement of goals',
    'Допомога': 'Help',
    'Про нас': 'About us',
    'Компанія': 'Company',
    'Наші пропозиції': 'Our proposals',
    'Конфіденційність': 'Privacy',
    'Умови користування': 'Terms of use',
    'Поширені запитання': 'Frequently asked questions',
    'Сервіси': 'Services',
    'Пошук роботи': 'Job search',
    'Пошук робітників': 'Search for workers',
    'Долучайтеся до нас': 'Join us',
    'Телефони': 'Phone',
    'Щодо нас і нашого проекту:': 'About us and our project:',
    'Ласкаво просимо до Placyy – інноваційної платформи, яка забезпечує простий та ефективний пошук роботи та кандидатів. Ми змінюємо правила гри, забезпечуючи шукачам роботи зручний доступ до актуальних вакансій поблизу їхнього місця проживання. Роботодавці отримують можливість швидко та з легкістю знаходити висококваліфікованих працівників в своєму регіоні.': 'Welcome to Placyy, an innovative platform that provides a simple and effective job and candidate search. Were changing the game by providing job seekers with convenient access to up-to-date jobs near where they live. Employers get the opportunity to quickly and easily find highly qualified employees in their region.',
    'Для Шукачів Роботи:': 'For Job Seekers:',
    'Placyy створено для тих, хто бажає знайти роботу, що відповідає їхнім потребам та місцю проживання. Ми пропонуємо актуальні вакансії у вашому регіоні, дозволяючи вам зекономити час та зосередитися на своєму карєрному розвитку.': 'Placyy is created for those who want to find a job that suits their needs and where they live. We offer relevant vacancies in your region, allowing you to save time and focus on your career development.',
    'Для Роботодавців:': 'For Employers:',
    'Placyy – це швидкий та зручний спосіб знаходження талановитих працівників. Ми допомагаємо ефективно закривати вакансії, використовуючи унікальний підхід до підбору кандидатів. З Placyy, ви отримуєте доступ до кваліфікованих фахівців, які вже знаходяться поруч.': 'Placyy is a fast and convenient way to find talented employees. We help to effectively close vacancies using a unique approach to candidate selection. With Placyy, you get access to qualified professionals who are already nearby.',
    'Placyy ви забудете про довгі поїздки на роботу та марно витрачений час на пошук кандидатів. Наша мета - зробити процес працевлаштування та підбору персоналу простим і ефективним. Приєднуйтеся до Placyy – де зустрічаються можливості та таланти, створюючи ідеальний соціальний та професійний звязок.': 'With Placyy, you will forget about long commutes and wasted time searching for candidates. Our goal is to make the process of employment and recruitment simple and effective. Join Placyy - where opportunities and talents meet, creating the perfect social and professional connection.',
    'Ефективний пошук роботи:': 'Effective job search:',
    'Placyy надає вам можливість знаходити роботу, яка відповідає вашим потребам і місцю проживання. Наша інноваційна система фільтрів і геолокації дозволяє вам зосередитися на найважливіших критеріях та швидко знайти ідеальну вакансію.': 'Placyy gives you the opportunity to find a job that suits your needs and place of residence. Our innovative filter and geolocation system allows you to focus on the most important criteria and quickly find the perfect job.',
    'Швидке та зручне розміщення вакансій:': 'Quick and convenient placement of vacancies:',
    'Роботодавці можуть швидко та легко розмістити вакансії на Placyy, використовуючи наші зручні інструменти. Наша платформа допомагає вам привертати увагу кандидатів, забезпечуючи ефективний і економічний процес найму.': 'Employers can quickly and easily post jobs on Placyy using our convenient tools. Our platform helps you capture the attention of candidates by providing an efficient and cost-effective hiring process.',
    'Географічна привабливість:': 'Geographical attractiveness:',
    'Як шукач роботи або роботодавець, ви отримуєте перевагу доступу до локальних можливостей. Placyy створює місцеві звязки, дозволяючи вам швидко знаходити роботу або кандидатів у вашому регіоні. Ви більше не обмежені глобальним пошуком, ми пропонуємо можливості прямо під вашим порогом.': 'As a job seeker or employer, you benefit from access to local opportunities. Placyy creates local connections, allowing you to quickly find jobs or candidates in your area. You are no longer limited by a global search, we offer opportunities right at your doorstep.',
    'Договір оферти Сервісу Placyy': 'Placyy Service Offer Agreement',
  },
};
